import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { useLang } from "./i18n";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use((c) => {
  const tk = localStorage.getItem("mx_token");
  if (tk) c.headers.Authorization = `Bearer ${tk}`;
  return c;
});

export const mediaUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const formatPrice = (p, lang) =>
  p?.price ? new Intl.NumberFormat(lang === "sk" ? "sk-SK" : "en-GB", { style: "currency", currency: p.currency || "EUR", maximumFractionDigits: 0 }).format(p.price) : null;

const SiteCtx = createContext({ settings: {}, countries: [], reload: () => {} });

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [countries, setCountries] = useState([]);
  const reload = () => {
    api.get("/settings").then((r) => setSettings(r.data || {})).catch(() => {});
    api.get("/countries").then((r) => setCountries(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  };
  useEffect(() => { reload(); }, []);
  return <SiteCtx.Provider value={{ settings, countries, reload }}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);

export const useContent = () => {
  const { settings } = useSite();
  const { t, tr } = useLang();
  const c = settings?.content || {};
  return {
    txt: (key) => tr(c.texts?.[key]) || t[key] || "",
    img: (key, fb) => mediaUrl(c[key]) || fb,
    imgs: (key, fb) => (Array.isArray(c[key]) && c[key].length ? c[key].map(mediaUrl) : fb),
    raw: c,
  };
};

export const waLink = (number, text) => {
  const n = String(number || "").replace(/[^\d]/g, "");
  return n ? `https://wa.me/${n}${text ? `?text=${encodeURIComponent(text)}` : ""}` : "";
};

export const locationOf = (p, countries, tr) => {
  const c = countries.find((x) => x.id === p?.country_id);
  const r = c?.regions?.find((x) => x.id === p?.region_id);
  return [r && tr(r.name), c && tr(c.name)].filter(Boolean).join(", ");
};
